import { Injectable, inject } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiEnvironmentService } from '../services/settings/api-environment.service';

/**
 * Sunny Street API bases, current first. The API is same-origin with the PWA since 2026-10
 * (https://sunnystreet.app/api, https://dev.sunnystreet.app/api); the api.*.sunnystreet.com
 * hosts are legacy aliases kept so any hard-coded or cached URL still reaches the selected
 * environment.
 */
export const KNOWN_API_BASES: readonly string[] = [
  'https://dev.sunnystreet.app',
  'https://sunnystreet.app',
  'https://api.dev.sunnystreet.com',
  'https://api.sunnystreet.com',
];

/** API paths only: the bases above also serve the PWA's own files, which must not be touched. */
export function isApiUrl(url: string, base: string): boolean {
  if (!base || !url.startsWith(base)) {
    return false;
  }
  const path: string = url.slice(base.length);
  return path.startsWith('/api/') || path === '/ws' || path.startsWith('/ws/') || path.startsWith('/ws?');
}

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
  private apiEnvironmentService = inject(ApiEnvironmentService);

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentApiUrl: string = this.apiEnvironmentService.getCurrentApiUrl();
    const knownBase: string | undefined = KNOWN_API_BASES.find((base: string) => isApiUrl(request.url, base));

    if (knownBase && knownBase !== currentApiUrl) {
      return next.handle(request.clone({ url: currentApiUrl + request.url.slice(knownBase.length) }));
    }

    return next.handle(request);
  }
}
